import React from 'react';
import PropTypes from 'prop-types';

import SearchFormEditor from './editor/SearchFormEditor';
import SearchClearButton from '../../form/SearchClearButton';

import './SearchFormInput.scss';

const SearchFormInput = React.forwardRef(function SearchFormInput(props, ref) {
    const { results, searchQuery, clearSearch } = props;

    const hasSearch = (searchQuery && searchQuery.length > 0) || (results && results.size > 0);

    return (
        <div className="SearchFormInput">
            <SearchFormEditor {...props} ref={ref} />
            <SearchClearButton show canClear={hasSearch} onClick={clearSearch} />
        </div>
    );
});

SearchFormInput.propTypes = {
    focusedIndex: PropTypes.number,
    searchQuery: PropTypes.string,
    results: PropTypes.object,
    submitSearch: PropTypes.func,
    closeSearch: PropTypes.func,
    clearSearch: PropTypes.func,
    onChange: PropTypes.func,
    handleSubmit: PropTypes.func,
    disabled: PropTypes.bool,
};

export default SearchFormInput;
